// @ts-nocheck
// ====== Export PDF scheda cliente ======
// Due entry-point:
//   - exportClientePDF(nome)             -> file singolo cliente
//   - exportSelectedClientiPDF(names[])  -> file con N clienti, uno per pagina
//
// Internamente: renderClientePages(doc, cli) disegna la scheda di UN cliente
// sul documento `doc` già aperto. Per il singolo file viene creato un doc nuovo.

import { jsPDF } from 'jspdf';

function renderClientePages(doc, cli, opts = {}) {
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 40;
  // Stato locale: y avanza durante il rendering. Per ogni nuovo cliente
  // (modalità multi-PDF) `opts.startNewPage = true` aggiunge una pagina prima.
  if (opts.startNewPage) {
    doc.addPage();
  }
  let y = M;

  const line = () => {
    doc.setDrawColor(220);
    doc.line(M, y, W - M, y);
    y += 14;
  };
  const ensure = (need) => {
    if (y + need > H - M) {
      doc.addPage();
      y = M;
    }
  };
  const h1 = (t) => {
    ensure(28);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(18);
    doc.setTextColor(26, 34, 56);
    doc.text(t, M, y);
    y += 24;
  };
  const h2 = (t) => {
    ensure(20);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setTextColor(37, 99, 235);
    doc.text(t, M, y);
    y += 16;
  };
  const kv = (label, value) => {
    ensure(16);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(107, 115, 144);
    doc.text(label, M, y);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(26, 34, 56);
    const wrapped = doc.splitTextToSize(String(value || '—'), W - M - 150);
    doc.text(wrapped, M + 130, y);
    y += Math.max(14, wrapped.length * 12);
  };
  const bullet = (t) => {
    ensure(14);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(26, 34, 56);
    const wrapped = doc.splitTextToSize('• ' + t, W - M * 2);
    doc.text(wrapped, M, y);
    y += wrapped.length * 12 + 2;
  };

  // Header: titolo + sottotitolo data
  doc.setFillColor(28, 169, 221);
  doc.rect(M, y, 32, 32, 'F');
  doc.setTextColor(255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.text('MS', M + 8, y + 22);
  doc.setTextColor(26, 34, 56);
  doc.setFontSize(14);
  doc.text('Portale Ma.Se. — Scheda cliente', M + 44, y + 14);
  doc.setFontSize(9);
  doc.setTextColor(107, 115, 144);
  doc.text(`Esportato il ${new Date().toLocaleString('it-IT')}`, M + 44, y + 28);
  y += 50;
  line();

  h1(cli.nome || '(senza nome)');
  h2('Anagrafica');
  kv('Client Partner & Lead (CPL)', cli.cpl);
  kv('Project Manager 1 (PM1)', cli.pm1);
  kv('Project Manager 2 (PM2)', cli.pm2);
  kv('Riferimento Service Line', cli.serviceLineRef);
  kv('Tenant ID', cli.tenantId);
  kv('Privilegi team', cli.ruolo);
  kv(
    'Tipo accesso',
    cli.assegnazionePerenne === 'si'
      ? 'Perenne'
      : cli.assegnazionePerenne === 'no'
        ? 'On-demand'
        : '—'
  );
  kv('Directory', cli.directory);
  kv('PIM', cli.pim);
  kv('Perimetri', (cli.perimetri || []).join(', ') || '—');
  kv('Tecnici dedicati', (cli.tecnici || []).join(', ') || '—');
  if (cli.note) kv('Note', cli.note);

  y += 8;
  ensure(40);
  h2('Accessi del team');
  const acc = cli.accessi || {};
  const accRows = state.resources.map((r) => [r, acc[r] || '—']);
  if (!accRows.length) bullet('Nessuna risorsa censita');
  else accRows.forEach(([r, s]) => kv(r, s));

  if (cli.contratto && Object.values(cli.contratto).some((v) => v && String(v).trim())) {
    y += 8;
    h2('Contratto');
    const ct = cli.contratto;
    kv('Numero', ct.numero);
    kv('Tipo', ct.tipo);
    kv('Inizio', fmtDate(ct.inizio));
    kv('Fine', fmtDate(ct.fine));
    kv('Ore', ct.ore);
    kv('Importo', ct.importo);
    if (ct.note) kv('Note', ct.note);
  }

  if ((cli.referenti || []).length) {
    y += 8;
    h2('Referenti cliente');
    cli.referenti.forEach((r) => {
      bullet(
        `${r.nome || '(senza nome)'}${r.ruolo ? ' — ' + r.ruolo : ''}${r.email ? ' — ' + r.email : ''}${r.telefono ? ' — ' + r.telefono : ''}`
      );
    });
  }

  if ((cli.documenti || []).length) {
    y += 8;
    h2('Documenti');
    cli.documenti.forEach((d) => {
      bullet(
        `${d.titolo || '(senza titolo)'}${d.tipo ? ' [' + d.tipo + ']' : ''} — ${d.url || ''}`
      );
    });
  }

  if ((cli.scadenze || []).length) {
    y += 8;
    h2('Scadenze');
    cli.scadenze.forEach((s) => {
      bullet(
        `${s.titolo || '(senza titolo)'}${s.tipo ? ' [' + s.tipo + ']' : ''}${s.data ? ' — ' + fmtDate(s.data) : ''}${s.completata ? ' (COMPLETATA)' : ''}`
      );
    });
  }
}

function finalizeFooter(doc) {
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 40;
  const pageCount = doc.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(107, 115, 144);
    doc.text('Portale Ma.Se. — Agic Technology — Riservato', M, H - 18);
    doc.text(`Pagina ${i}/${pageCount}`, W - M - 60, H - 18);
  }
}

function exportClientePDF(clienteName) {
  const cli = state.clients.find((c) => c.nome === clienteName);
  if (!cli) {
    toast('Cliente non trovato');
    return;
  }
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  renderClientePages(doc, cli);
  finalizeFooter(doc);
  const fileName = `cliente-${(cli.nome || 'export').replace(/[^a-zA-Z0-9_-]/g, '_').slice(0, 50)}-${new Date().toISOString().slice(0, 10)}.pdf`;
  doc.save(fileName);
}

function exportSelectedClientiPDF(names) {
  const list = (names || []).map((n) => state.clients.find((c) => c.nome === n)).filter(Boolean);
  if (!list.length) {
    toast('Nessun cliente selezionato (usa le checkbox della tabella)');
    return;
  }
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  list.forEach((cli, i) => renderClientePages(doc, cli, { startNewPage: i > 0 }));
  finalizeFooter(doc);
  const today = new Date().toISOString().slice(0, 10);
  doc.save(`portale-mase_clienti_${list.length}_${today}.pdf`);
  toast(`Export PDF: ${list.length} client${list.length === 1 ? 'e' : 'i'}`);
  logAudit?.({
    action: 'system',
    entity: 'Export',
    target: 'PDF multi-cliente',
    details: `Esportati ${list.length} clienti in PDF`
  });
}

// btnExportPdfBulk vive nella vista "clienti" (lazy): wiring idempotente.
function wirePdfBulk() {
  bindOnce(document.getElementById('btnExportPdfBulk'), 'click', () => {
    const sel = globalThis._bulkSelected ? Array.from(globalThis._bulkSelected) : [];
    exportSelectedClientiPDF(sel);
  });
}
document.addEventListener('DOMContentLoaded', wirePdfBulk);
globalThis.bus?.on?.('view:lazy-loaded', (p) => {
  if (p && p.viewId === 'clienti') wirePdfBulk();
});

globalThis.exportClientePDF = exportClientePDF;
globalThis.exportSelectedClientiPDF = exportSelectedClientiPDF;
export {};
